import { call, put, takeEvery } from "redux-saga/effects"

import { RESET_USER_COURSE } from "./actionTypes"
import { resetUserCourseSuccess, resetUserCourseError } from "./actions"

import { resetUserCourseApi } from "../../../helpers/backend_helper"

function* reset(action) {
  try {
    const response = yield call(resetUserCourseApi, action.payload.form)
    if (response == undefined) throw new Error("API error")
    yield put(resetUserCourseSuccess())
  } catch (error) {
    yield put(resetUserCourseError(error.message))
  }
}

function* userCourseResetSaga() {
  yield takeEvery(RESET_USER_COURSE, reset)
}

export default userCourseResetSaga